module.exports = __webpack_public_path__ + "static/media/user.faea66de.svg";